import TabRegion from '../models/components/TabRegion';

const getTabPanelProps = (tabId: string, region: TabRegion) => {
    return {
        role: 'tabpanel',
        id: `tabpanel-${region}-${tabId}`,
        'aria-labelledby': `tab-${region}-${tabId}`,
    };
};

export default getTabPanelProps;



// WEBPACK FOOTER //
// ./src/utils/getTabPanelProps.ts